<template>
  <div class="xero-wrap">
    <div class="logo"></div>
    <div class="clear">
        <div class='back_box' @click="prev">
            <i class="el-icon-back"></i> Back
        </div>
        <div class="pro">
            <div class="tit">3 / 4</div>
            <el-progress :percentage="75"></el-progress>
        </div>
    </div>
    <div class="title">Registered Peiso</div>
    <div class="bgd">
      <div class="con">
        <h1>Set Up Your Rent</h1>
        <h2>Lease End Date</h2>
        <div class="dateItem">
          <el-date-picker
            style="opacity:0;z-index:1"
            v-model="date"
            type="date"
            format="dd/MM/yyyy"
            :editable="false"
            :clearable="false"
            placeholder="">
          </el-date-picker>
          <div style="position: absolute;
          left: 60px;
          top: 0;
          line-height: 50px;
          font-size: 18px;color:var(--text-color);">{{showDate}}</div>
        </div>
        <h2>Does the Rental Agreement include outgoings?</h2>
        <div class="radioItem clear">
          <div class="radio">
            <el-radio v-model="boo" label="1">Yes</el-radio>
          </div>
          <div class="radio">
            <el-radio v-model="boo" label="2">No</el-radio>
          </div>
        </div>

        <div class="inputItem prefix-customize">
            <h2>Monthly Rental Cost</h2>
            <el-input prefix-icon="$" type="text" v-model="cost" @input="validate('cost')" maxlength="13" />
            <!--<span class="lft">$</span>-->
        </div>
        <div class="inputItem prefix-customize">
            <h2>Annual Rental Cost</h2>
            <el-input prefix-icon="$" type="text" v-model="cost1" @input="validate('cost1')" maxlength="13" />
            <!--<span class="lft">$</span>-->
        </div>

        <h2>Yearly Rental Increase In % Or $ Value</h2>
        <div class="radioItem clear">
          <div class="radio input suffix-customize">
            <el-radio v-model="boo2" label="1" @change="radioChange"></el-radio>
            <el-input suffix-icon="%" type="text" :disabled="boo2 === '1' ? false : true" :style="{'cursor': boo2 === '1' ? 'pointer' : 'not-allowed'}" v-model="percentage" maxlength="5" @input="validate('percentage')" />
            <!--<span class="percentage">%</span>-->
          </div>
          <div class="radio input prefix-customize">
            <el-radio v-model="boo2" label="2" @change="radioChange"></el-radio>
            <el-input prefix-icon="$" type="text" :disabled="boo2 === '2' ? false : true" :style="{'cursor': boo2 === '2' ? 'pointer' : 'not-allowed'}" v-model="dollar" maxlength="5" @input="validate('dollar')" />
          </div>
        </div>
        <h2>Yearly Rental Increase Date</h2>
        <div class="monItem">
          <el-cascader style="opacity:0;z-index:1" :options="dateOptions" separator=" " placeholder="" v-model="time"></el-cascader>
          <div style="position: absolute;
          left: 60px;
          top: 0;
          line-height: 50px;
          font-size: 18px;color:var(--text-color);">{{showTime}}</div>
        </div>
        <h2>Rent Free Period</h2>
        <div class="inputItem suffix-months-customize">
          <el-input type="text" suffix-icon="months" v-model="period" maxlength="10" @input="validate('period')" />
        </div>
        <h2>Additional Amount</h2>
        <div class="inputItem prefix-customize" style="margin-bottom: 60px">
          <el-input prefix-icon="$" type="text" v-model="amount" maxlength="10" @input="validate('amount')" />
        </div>
        <div class="btm-btns clear">
          <button class="next" @click="confirm">Next</button>
          <button class="skip" @click="$router.replace('/pay')">Skip</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
      dateOptions: [{
          value: '01',
          label: 'Jan',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '02',
          label: 'Feb',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }]
      }, {
          value: '03',
          label: 'Mar',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '04',
          label: 'Apr',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '05',
          label: 'May',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '06',
          label: 'June',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '07',
          label: 'Jul',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '08',
          label: 'Aug',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '09',
          label: 'Sept',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '10',
          label: 'Oct',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }, {
          value: '11',
          label: 'Nov',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }]
      }, {
          value: '12',
          label: 'Dec',
          children: [{
            value: '01',
            label: '01',
          }, {
            value: '02',
            label: '02',
          }, {
            value: '03',
            label: '03',
          }, {
            value: '04',
            label: '04',
          }, {
            value: '05',
            label: '05',
          }, {
            value: '06',
            label: '06',
          }, {
            value: '07',
            label: '07',
          }, {
            value: '08',
            label: '08',
          }, {
            value: '09',
            label: '09',
          }, {
            value: '10',
            label: '10',
          }, {
            value: '11',
            label: '11',
          }, {
            value: '12',
            label: '12',
          }, {
            value: '13',
            label: '13',
          }, {
            value: '14',
            label: '14',
          }, {
            value: '15',
            label: '15',
          }, {
            value: '16',
            label: '16',
          }, {
            value: '17',
            label: '17',
          }, {
            value: '18',
            label: '18',
          }, {
            value: '19',
            label: '19',
          }, {
            value: '20',
            label: '20',
          }, {
            value: '21',
            label: '21',
          }, {
            value: '22',
            label: '22',
          }, {
            value: '23',
            label: '23',
          }, {
            value: '24',
            label: '24',
          }, {
            value: '25',
            label: '25',
          }, {
            value: '26',
            label: '26',
          }, {
            value: '27',
            label: '27',
          }, {
            value: '28',
            label: '28',
          }, {
            value: '29',
            label: '29',
          }, {
            value: '30',
            label: '30',
          }, {
            value: '31',
            label: '31',
          }]
      }],
      date: null,
      showDate: null,
      // Does the Rental Agreement include outgoings
      boo: null,
      // Yearly Rental Increase In % Or $ Value
      boo2: null,
      percentage: '',
      dollar: '',

      // Monthly Rental Cost
      cost: '',
      cost1: '', // 2021-7-26 add new params
      // 选中的日期
      time: null,
      showTime: null,
      period: '',
      amount: '',
      // 是否输入完整
      isComplete: false
    }
  },
  created () {
    if (!sessionStorage.getItem('request_params')) {
      this.$router.replace('/register')
    }
  },
  methods: {
    radioChange() {
      console.log(this.boo2)
      if (this.boo2 === '1')
        this.dollar = ''
      else
        this.percentage = ''
    },
    validate (type) {
      var that = this
      if (type === 'cost') {
        this.cost = this.cost.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.cost1 = Utils.formatDecimal(this.cost * 12,2)
      } else if (type === 'cost1') {
        this.cost1 = this.cost1.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
        this.cost = Utils.formatDecimal(this.cost1 / 12,2)
      } else if (type === 'period') {
        this.period = this.period.replace(/[^\d]/g,'')
      } else if (type === 'amount') {
        this.amount = this.amount.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
      }
    },
    confirm() {
      let timeList = []
      let leaseEndDate = ''
      if (this.date !== '' && this.date !== null)
        leaseEndDate = ((new Date(this.date)).getTime()) / 1000
      // const yearlyRentalIncreaseDate = ((new Date(this.time)).getTime()) / 1000
      let yearlyRentalIncreaseDate = ''
      if (this.time !== null && this.time !== '')
        yearlyRentalIncreaseDate = this.time[0] + '-' + this.time[1]

      let request_params = JSON.parse(sessionStorage.getItem('request_params'))

      request_params.additionalAmount = this.amount === '' ? null : this.amount.indexOf('.') == -1 ? parseInt(this.amount) : parseFloat(this.amount)
      request_params.leaseEndDate = leaseEndDate !== '' ? leaseEndDate : null
      request_params.monthlyRentalCost = this.cost !== '' ? (this.cost.indexOf('.') == -1 ? parseInt(this.cost) : parseFloat(this.cost)) : null
      request_params.yearRentalCost = this.cost1 !== '' ? (this.cost1.indexOf('.') == -1 ? parseInt(this.cost1) : parseFloat(this.cost1)) : null
      request_params.rentFreePeriod = this.period
      request_params.yearlyRentalIncreaseDate = yearlyRentalIncreaseDate === '' ? null : yearlyRentalIncreaseDate
      request_params.includeOutgoings = this.boo === null ? null : (this.boo === '1' ? 1 : 0)


      if (this.boo2 !== null && this.boo2 !== '') {
        if (this.boo2 === '1') {
          if (this.percentage === '') {
            request_params.yearlyRentalIncreaseType = 1
            request_params.yearlyRentalIncrease = 0
          } else {
            request_params.yearlyRentalIncreaseType = 1
            request_params.yearlyRentalIncrease = parseFloat(this.percentage)
          }
        } else {
          if (this.dollar === '') {
            request_params.yearlyRentalIncreaseType = 0
            request_params.yearlyRentalIncrease = 0
          } else {
            request_params.yearlyRentalIncreaseType = 0
            request_params.yearlyRentalIncrease = parseFloat(this.dollar)
          }
        }
      }

      console.log(request_params)

      sessionStorage.removeItem('request_params')
      sessionStorage.setItem('request_params', JSON.stringify(request_params))
      this.$router.replace('/pay')

    },
      prev () {
        this.$router.replace('/time')
      }
  },
}
</script>

<style lang="scss" scoped>
.xero-wrap{
  color: var(--text-color);
  padding-bottom: 50px;
  min-width: 1200px;
  .bgd{
    width: 100%;
    background: var(--background-color-4);
    padding: 50px 0 65px 0;
    //margin-bottom: 50px;
    .con{
      width: 740px;
      margin: 0 auto;
      .btm-btns{
        width: 100%;
        margin: 0 auto;
        button{
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          float: left;
          box-sizing: border-box;        
          font-size: 26px;
          cursor: pointer;
        }
        .skip{
          border: 2px solid var(--text-color);
          font-family: PingFangSC-Semibold, PingFang SC;
          color: var(--text-color);
        }
        .next{
          margin-right: 50px;
          border: 2px solid #EA3796;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: #EA3796;
        }
      }
      h1{
        font-family: 'PingFangSC-Semibold';
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h2{
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 10px;
      }
      .inputItem{
        width: 100%;
        margin-bottom: 30px;
        position: relative;
        input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: var(--background-color-2);
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: var(--text-color);
          height: 50px;
        }
        .el-input{
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: var(--background-color-2);
          width: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: var(--text-color);
          height: 50px;
        }
        .lft{
          position: absolute;
          left: 20px;
          line-height: 50px;
          color: var(--text-color);
        }
        .rgt{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: var(--text-color);
        }
      }
      .radioItem{
        font-size: 20px;
        line-height: 28px;
        margin-bottom: 41px;
        .radio{
          width: 355px;
          float: left;
          position: relative;
        }
        .el-input{
          width: 318px;
          height: 50px;
          outline: none;
          border: 1px solid rgba(95,95,95,1);
          background: var(--background-color-2);
          box-sizing: border-box;
          padding: 0 15px;
          font-family: 'SFProText-Regular';
          font-size: 20px;
          color: var(--text-color);
        }
        .radio:nth-child(1){
          margin-right: 30px;
          input{
            padding: 0 40px 0 15px;
          }
        }
        .radio:nth-child(2){
          input{
            padding: 0 15px 0 40px;
          }
        }
        .percentage{
          position: absolute;
          right: 20px;
          line-height: 50px;
          color: var(--text-color);
        }
        .dollar{
          position: absolute;
          left: 56px;
          line-height: 50px;
          color: var(--text-color);
        }
      }
      .dateItem{
        margin-bottom: 30px;
        position:relative;border-radius: 0;
        border: 1px solid var(--background-color-4);
        background-color: var(--background-color-2);
        height: 50px;
        color: var(--text-color);
        font-family: 'SFProText-Regular';
        font-size: 20px;
        color: var(--background-color-3);
        background-size: 23px 22px;
        background-position: 16px center;
        background-repeat: no-repeat;
        background-image: url('../../assets/c2.png');
      }
      .monItem{
        margin-bottom: 30px;
        position:relative;border-radius: 0;
        border: 1px solid var(--background-color-4);
        background-color: var(--background-color-2);
        height: 50px;
        color: var(--text-color);
        font-family: 'SFProText-Regular';
        font-size: 20px;
        color: var(--background-color-3);
        background-size: 23px 22px;
        background-position: 16px center;
        background-repeat: no-repeat;
        background-image: url('../../assets/c2.png');
      }
    }
  }
}

.pro{
    margin-bottom: 30px;
    width: 200px;
    float: right;
    .tit{
        text-align: right;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #EA3796;
        line-height: 22px;
    }
}
.title{
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: var(--text-color);
    line-height: 33px;
    margin-bottom: 39px;
}
.back_box{
  float: left;
  width: 150px;
  font-size:14px;
  font-weight:600;
  color:var(--text-color);
  line-height:20px;
  cursor: pointer;
  .el-icon-back{
    margin-right: 10px;
    font-size: 20px;
    position: relative;
    top: 3px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/register/rent.vue